import { useCallback } from 'react'

import {
  getHasDismissedOnboardingTooltip,
  getHasSavedTemplateOrItem,
  setHasDismissedOnboardingTooltip,
  setHasSavedTemplateOrItem,
} from 'tripPlanner/storage/curatedTripOnboardingTooltip'

export default function useSaveButtonOnboardingTooltipRules() {
  const setUserHasSaved = useCallback(() => {
    setHasSavedTemplateOrItem(true)
  }, [])

  const setTooltipWasDismissed = useCallback(
    () => setHasDismissedOnboardingTooltip(true),
    [],
  )

  const userHasDismissedTooltip = getHasDismissedOnboardingTooltip()
  const userHasSavedTemplateItem = getHasSavedTemplateOrItem()

  return {
    isTooltipOpen: !userHasSavedTemplateItem && !userHasDismissedTooltip,
    setTooltipWasDismissed,
    setUserHasSaved,
  }
}
